import { TournamentFormat } from 'src/generated/graphql';

import { getI18n } from 'react-i18next';

export const getTournamentFormats = () => {
  const i18n = getI18n();
  return {
    [TournamentFormat.SingleElimination]: i18n.t(
      'tournament-formats.single-elimination'
    ),
    [TournamentFormat.PrunedSingleElimination]: i18n.t(
      'tournament-formats.single-elimination'
    ),
    [TournamentFormat.PrunedDoubleElimination]: i18n.t(
      'tournament-formats.double-elimination',
      'D.E.'
    ),
  };
};

export const getTournamentFormat = (tournament: {
  __typename: string;
  tournamentFormat: TournamentFormat;
}) => {
  if (tournament.__typename !== 'Tournament') {
    return '--';
  }

  return getTournamentFormats()[tournament.tournamentFormat];
};
